export const GET_OPERATOR_FLEET_DETAIL_START = "GET_OPERATOR_FLEET_DETAIL_START"
export const GET_OPERATOR_FLEET_DETAIL_SUCCESS = "GET_OPERATOR_FLEET_DETAIL_SUCCESS"
export const GET_OPERATOR_FLEET_DETAIL_ERROR= "GET_OPERATOR_FLEET_DETAIL_ERROR"

export const DOCUMENT_EXPIRED_START = "DOCUMENT_EXPIRED_START"
export const DOCUMENT_EXPIRED_SUCCESS = "DOCUMENT_EXPIRED_SUCCESS"
export const DOCUMENT_EXPIRED_ERROR= "DOCUMENT_EXPIRED_ERROR"